import React, { Dispatch, SetStateAction, useEffect, useRef } from 'react';
import { css } from '@emotion/css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Color } from 'css/theme';

import { SortOption } from './index';

const classes = {
  select: (isOpen: boolean) => css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-radius: 100px;
    padding: 13px 8px 13px 20px;
    cursor: pointer;
    background-color: ${isOpen ? Color.Purple400 : Color.White};
    border: 1px solid ${Color.Purple400};
    width: 100%;

    @media (min-width: 1288px) {
      border: 1px solid ${isOpen ? Color.Blue400 : Color.Purple400};
      background-color: ${Color.White};

      :hover {
        background-color: ${Color.Purple400};
        color: ${Color.White};
      }
    }
  `,
  caret: (isDropdownOpen: boolean) => css`
    font-size: 14px;
    padding: 0px 12px;
    box-sizing: content-box;
    transition: transform 0.3s;
    transform: rotate(${isDropdownOpen ? 180 : 0}deg);

    @media (max-width: 1288px) {
      color: ${isDropdownOpen ? Color.White : Color.Gray800};
    }
  `,
  label: (isDropdownOpen: boolean) => css`
    font-size: 14px;
    line-height: 22px;

    @media (max-width: 1288px) {
      color: ${isDropdownOpen ? Color.White : Color.Gray800};
    }
  `,
};

const DEFAULT_SORT_DISPLAY_VALUE = 'Sort by';

type Props = {
  isOpen: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  activeOption: SortOption;
};

const SelectLabel: React.FC<Props> = ({ isOpen = false, activeOption, setOpen }) => {
  const selectRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClick = event => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener('click', handleClick);

    return () => document.removeEventListener('click', handleClick);
  }, [selectRef]);

  return (
    <>
      <div ref={selectRef} onClick={() => setOpen(prev => !prev)} className={classes.select(isOpen)}>
        <div className={classes.label(isOpen)}>{activeOption ? activeOption.label : DEFAULT_SORT_DISPLAY_VALUE}</div>
        <FontAwesomeIcon className={classes.caret(isOpen)} icon={['fas', 'caret-down']} />
      </div>
    </>
  );
};

export default SelectLabel;
